import React from 'react';
import { toast } from 'react-toastify';

const StatusModal = ({
    showStatusModal,
    setShowStatusModal,
    selectedStatus,
    statusText,
    setStatusText,
    statusDuration,
    setStatusDuration,
    setCurrentStatus,
}) => {
    if (!showStatusModal) return null;

    return (
        <div
            className="status-modal-overlay"
            onClick={() => setShowStatusModal(false)}
        >
            <div
                className="status-modal"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="status-modal-header">
                    <h2>
                        {selectedStatus === 'dnd' && 'Do Not Disturb'}
                        {selectedStatus === 'away' && 'Set as Away'}
                        {selectedStatus === 'custom' && 'Add Status'}
                        {selectedStatus === 'brb' && 'Be Right Back'}
                        {selectedStatus === 'commuting' && 'Commuting'}
                        {selectedStatus === 'sick' && 'Out Sick'}
                        {selectedStatus === 'vacation' && 'Vacationing'}
                    </h2>

                    <button
                        type="button"
                        className="status-close-btn"
                        onClick={() => setShowStatusModal(false)}
                    >
                        ✕
                    </button>
                </div>

                <input
                    type="text"
                    className="status-input"
                    value={statusText}
                    onChange={(e) => setStatusText(e.target.value)}
                    placeholder="Example: In parent conference"
                />

                <select
                    className="status-time-select"
                    value={statusDuration}
                    onChange={(e) => setStatusDuration(e.target.value)}
                >
                    <option>15 Minutes</option>
                    <option>30 Minutes</option>
                    <option>1 Hour</option>
                    <option>Today</option>
                    <option>Tomorrow</option>
                    <option>This Week</option>
                    <option>Custom Date</option>
                    <option>Custom Date Range</option>
                </select>

                <div className="status-modal-actions">
                    <button
                        type="button"
                        className="status-cancel-btn"
                        onClick={() => setShowStatusModal(false)}
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        className="status-save-btn"
                        onClick={() => {
                            setCurrentStatus({
                                type: selectedStatus,
                                text:
                                    statusText ||
                                    (selectedStatus === 'away'
                                        ? 'Away'
                                        : selectedStatus === 'brb'
                                            ? 'Be Right Back'
                                            : selectedStatus === 'commuting'
                                                ? 'Commuting'
                                                : selectedStatus === 'sick'
                                                    ? 'Out Sick'
                                                    : selectedStatus === 'vacation'
                                                        ? 'Vacationing'
                                                        : 'Custom Status'),
                                duration: statusDuration,
                            });

                            setShowStatusModal(false);
                            setStatusText('');
                            setStatusDuration('30 Minutes');


                        }}
                    >
                        Save Status
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StatusModal;